<template>
  <section class="testimonials container">
    <h2>{{ testimonials.title }}</h2>
    <p v-html="testimonials.description"></p>
    <div
      :class="isDesktop || isTestimonialPage
        ? `d-flex ${testimonials.articles.length > 3 ? 'flex-wrap justify-content-start' : 'flex-column flex-lg-row'}`
        : 'd-none'"
    >
      <TestimonialsSwiperCard
        :class="{
          'custom-width mb60': testimonials.articles.length > 3,
          'w-100': testimonials.articles.length <= 3,
          'mb-5': testimonials.articles.length <= 3 && !isDesktop
        }"
        v-for="card in testimonials.articles" :key="card.id"
        :card="card"
        :shouldHaveContainer="isDesktop || isTestimonialPage"
        :shouldHaveQuates="isTestimonialPage"
      />
    </div>
    <div :class="!isDesktop && !isTestimonialPage ? 'swiper-carousel' : 'swiper-carousel d-none'">
      <swiper
        :slides-per-view="swiperOptions.slidesPerView"
        :space-between="50"
        :breakpoints="swiperOptions.breakpoints"
        :modules="swiperOptions.modules"
        :navigation="true"
      >
        <swiper-slide
          v-for="card in testimonials.articles"
          :key="card.id"
          :class="testimonials.articles.length < 2 ? 'w-100' : ''"
        >
          <TestimonialsSwiperCard :card="card"/>
        </swiper-slide>
      </swiper>
    </div>
    <div
      class="mt-3 d-flex justify-content-center contact-btn"
      v-if="!isTestimonialPage">
      <ButtonRed
        v-if="testimonials.contactButton.showModalButton"
        :text="testimonials.contactButton.title"
        @click="handleModal"
      />
    </div>
    <ModalForm
      v-if="!isTestimonialPage"
      :modal="testimonials.contactButton.modal"
      :successModalData="testimonials.contactButton.successModal"
      :show="showModal"
      @handleModal="handleModal"
    />
  </section>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from 'swiper';
import TestimonialsSwiperCard from "@/components/testimonials/TestimonialsSwiperCard";
import {handleListeners} from '@/utils/utils'
import ModalForm from "@/components/common/modals/ModalForm.vue";
import ButtonRed from "@/components/common/ButtonRed.vue";
import {ref} from "vue";

export default {
  components: {
    ButtonRed, ModalForm,
    TestimonialsSwiperCard,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        breakpoints: {
          580: {
            slidesPerView: this.$props.testimonials.articles.length === 1 ? 1 : 2
          },
          992: {
            slidesPerView: this.$props.testimonials.articles.length === 1 ? 1 : 3
          },
        },
        modules: [Navigation]
      },
      isDesktop: false,
      isTestimonialPage: false
    }
  },
  props: {
    testimonials: {
      title: String,
      description: HTMLElement,
      articles: Array,
      contactButton: {
        title: String,
        showModalButton: String,
        modal: Object,
        successModal: Object
      }
    }
  },
  setup() {
    const showModal = ref(false)
    return {showModal}
  },
  methods: {
    setIsDesktop() {
      this.isDesktop = window.visualViewport.width >= 992;
    },
    handleModal() {
      this.showModal = !this.showModal;
    }
  },
  mounted() {
    this.isDesktop = window.visualViewport.width >= 992;
    this.isTestimonialPage = window.location.href.includes('testimonials');
    handleListeners(['resize'], this.setIsDesktop)
  },
  unmounted() {
    handleListeners(['resize'], this.setIsDesktop, true)
  }
}
</script>
